export default __webpack_public_path__ + "767d2e9ade6ecb3eeaf64d2da80b4703.png";